import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReserveren = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M17.2 26H6l4-14h4.4z"
    />
    <path
      fill="#F8BADD"
      d="M34 28H12l-2-16h21.2z"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M15 17.5h13v1H15zM16 20.5h9v1h-9z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReserveren);

export default ForwardRef;
